import $ from 'jquery';
import 'bootstrap';
import './popup';

import Swiper from 'swiper';
import Sticky from 'sticky-js';
import SmoothScroll from 'smooth-scroll';


// services page navigation
(function( selector ){

    // init
    $(selector+' .-sm-nav .nav-item:first-child').addClass('active');

    // this selector must be unique
    var stick = new Sticky( selector , {
        responsiveWidth: true
    } );

    // use negative offset to avoid bad section detection with scrollspy
    var smoothie = new SmoothScroll( selector+' .nav-link[href*="#"]' , {header: '.main-header', speedAsDuration: true, offset: -5 } );

    // scroll spy listener
    $(window).on( 'activate.bs.scrollspy', function (e,obj) {
        if( obj ) { // on Edge, this function is called - sometimes - without object
            $(selector+' .-sm-nav .nav-item').removeClass('active');
            $(selector+' .-sm-nav a[href^="'+obj.relatedTarget+'"]').parents( '.nav-item' ).addClass('active');
        }
    });

    var select = $(selector+' .js-nav--controller');

    select.on( 'change',function(){
        var v = $(this).val();

        if( v && document.getElementById( v.substring( 1 ) ) ) {
            var anchor = document.getElementById( v.substring( 1 ) );
            smoothie.animateScroll( anchor );

        }

    } );


})( '.js-nav--sticky' );


// swiper homepage
(function( selector ){
    $(selector).each( function(){

        let that = $(this);
        new Swiper ( that , {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: 1.4,
            spaceBetween: 32,
            breakpointsInverse: true,
            navigation: {
                nextEl: that.parent().find('.js-swiper-button-next'),
                prevEl: that.parent().find('.js-swiper-button-prev'),
            },
            breakpoints: {
                // when window width is >= 640px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                }
            }
        });
    } );
})( '.js-swiper-container' );


// label as placeholder effect on contact page

// @see https://codepen.io/nathanlong/pen/kkLKrL
(function ( $ ) {

    // create basic pairs
    var pairs = [];
    $( 'input:not([type="checkbox"]):not([type="radio"]):not([type="text"]):not([type="email"]):not([type="submit"])[id], select[id], textarea[id], .form-item-phone-phone input[id]').each( function() {
        var input = $(this);
        var label = $('label[for="'+input.attr('id')+'"]');

        if( label.length ) {
            pairs.push( { trigger: input , target: label } );
        }
    } );
    // special pairs for phone number
    $('.phone-number-field').each( function(){
        pairs.push( { trigger: $(this).find('.js-form-item-phone-phone input') , target: $(this).find('label:first') } );

        // transpose error status on parent
        if( $(this).find('.js-form-item-phone-phone input').hasClass('error') ) {
            $(this).addClass('form-item--error');
        }
    } );

    var i = pairs.length;

    while( i-- ){

        (function( input , label ){
            input.focus( function( e ){
                label.addClass('-js-focused');
            } );
            input.blur( function( e ){
                if( input.val() === "" || input.val() === null || input.val() === undefined ) {
                    label.removeClass('-js-filled');
                } else {
                    label.addClass('-js-filled');
                }
                label.removeClass('-js-focused');
            } ).trigger('blur');

        } )( pairs[i].trigger , pairs[i].target );


    }
} )(jQuery);

//disable scroll when menu is open
(function ( $ ) {
const menuOpen = function() {
    $('.js-menu-open-toggler').on('click', function() {
        $('body').toggleClass('menu_open');
    })
}

const detectIos = function() {
    var isMobile = {
        iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },

    };

    if(isMobile.iOS()){
        $('.navbar-collapse').addClass('ios');
    };
}

// const fixCookieBotStyles = function() {
//     if ($('#CybotCookiebotDialogBodyLevelDetailsButton').length) {
//         $('#CybotCookiebotDialogBodyLevelDetailsButton').on('click', function() {
//             $('#CybotCookiebotDialog').toggleClass('details-open');
//         })
//     }
// }

// var jsErrorChange = function() {
//     if ($('.js-form-error-container').length) {
//         if($('.error').length) {
//             $('.js-form-error-container').find('form').addClass('form-error');
//         }
//     }
// }

    detectIos();
    menuOpen();
    // fixCookieBotStyles();


})(jQuery);





// (function ($, Drupal, drupalSettings) {
//
//     Drupal.behaviors.webform_ajax = {
//         attach: function (context, settings) {
//             jQuery('.webform-submission-form', context).once('#webform_submission_contact_add_form-ajax', function () {
//                 console.log('test');
//             });
//         }
//     };
//
// })(jQuery, Drupal, drupalSettings);








